import { render, staticRenderFns } from "./majorLog.vue?vue&type=template&id=e769213e&"
import script from "./majorLog.vue?vue&type=script&lang=js&"
export * from "./majorLog.vue?vue&type=script&lang=js&"
import style0 from "./majorLog.vue?vue&type=style&index=0&id=e769213e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports